import React from 'react';
import useTranslate from '../../../Hooks/useTranslate';
import { Stack, Tooltip, Button, Typography } from '@mui/material';
import { ColumnFlexBox, FlexBox, FullSizeFlexBox } from '../../FlexBox';
import CaptionValue from '../../CaptionValue/CaptionValue';
import SearchBox from '../../Inputs/SearchBox';
import SortButton from '../../Sorting/SortButton';
import FiltersButton from '../../Filters/FiltersButton';
import Excel from '../../Logos/Excel';
import useLocationName from '../../../Hooks/useLocationName';

const Header = function Header({
  title,
  caption,
  hideSearchBar,
  hideExportExcel,
  hideSorting,
  hideFilters,
  sortingOptions,
  searchValues,
  setSearchValues,
  customFilters,
  handleExportToExcel,
}) {
  const translate = useTranslate();
  const locationName = useLocationName();

  return (
    <ColumnFlexBox
      padding="24px 24px 8px 24px"
      minHeight="160px"
      width="100%"
      flexGrow={0}
      justifyContent="space-between"
    >
      <FullSizeFlexBox justifyContent="space-between">
        <CaptionValue
          caption={caption}
          value={
            <Typography
              variant="h4"
              sx={{ color: 'primary.main', fontSize: '30px' }}
            >
              {translate(title)}
            </Typography>
          }
          captionColor="#5A5A5A"
          captionStyle={{ textTransform: 'uppercase' }}
        />
        {!hideSearchBar && (
          <SearchBox
            setSearchValues={setSearchValues}
            searchValues={searchValues}
          />
        )}
      </FullSizeFlexBox>
      <FlexBox marginTop="0 auto" justifyContent="flex-end">
        <Stack direction="row" spacing={2}>
          {!hideExportExcel && (
            <Tooltip title={translate('EXPORT_EXCEL')}>
              <Button
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  padding: '6px 8px',
                  gap: '8px',
                  fontSize: '13px',
                }}
                variant="outlined"
                onClick={handleExportToExcel}
                color="success"
              >
                {translate('EXPORT_EXCEL')}
                <Excel />
              </Button>
            </Tooltip>
          )}
          <SortButton
            hidden={hideSorting}
            defaultSorting={searchValues?.sortValue}
            sortingOptions={sortingOptions}
          />
          <FiltersButton
            hidden={hideFilters}
            defaultFilters={searchValues}
            currentSection={locationName}
            customFilters={customFilters}
          />
        </Stack>
      </FlexBox>
    </ColumnFlexBox>
  );
};
export default Header;
